
export default class {
    /*SEGUIR EXATAMENTE ESTE PADRÃO CHAMANDO form: new XXX(), POIS SE MUDAR DARÁ ERRO COM OBJETO NÃO SENDO ALTERADO A CADA INCLUSÃO*/

    constructor() {

        return {
            quoteId: 0,
            quoteNumber: 0,
            quoteCodeLabel: "",
            companyId: 0,
            contactId: 0,
            typeBudgetRejectionReasonId:0,
            customerId: 0,
            finishedDate: "",
            issueDate: "",
            originQuoteId: 0,
            paymentPlanId: 0,
            registeredCustomer: true,
            sellerId: 0,
            shippingCompanyId: 0,
            shippingCost: 0,
            shippingIsAddTotal: true,
            shippingIsCustomer: true,
            conditionPayment: "",
            conditionDeadline: "",
            quoteStatusId: 0,
            additionalCost: 0,
            unregisteredContact: "",
            unregisteredCustomer: "",
            unregisteredEmail: "",
            unregisteredPhone: "",
            budgetRejectionNote: "",
            validity: "",
            note: "",
            status: 1,
            checklist:{

            }

        }

    }
}